import AnimationService from './Service/AnimationService'
import CssPreloadingService from './Service/CssPreloadingService'
import CursorBurstAnimationService from './Service/CursorBurstAnimationService'

const cssPreloadingService = new CssPreloadingService()
cssPreloadingService.init()

const animationService = new AnimationService()
animationService.observe()

const cursorBurstAnimationService = new CursorBurstAnimationService()
cursorBurstAnimationService.init()
